import { useEffect, useState } from 'react';

import bgImage01 from '../../assets/images/Welcome/01_NYK_Load_1.jpg';
import bgImage02 from '../../assets/images/Welcome/02_NYR_Load_1.jpg';
import bgImage03 from '../../assets/images/Welcome/03_NJD_Load_1.jpg';
import bgImage04 from '../../assets/images/Welcome/04_NYI_Load_1.jpg';
import bgImage05 from '../../assets/images/Welcome/05_BUF_Load_1.jpg';
import bgImage07 from '../../assets/images/Welcome/07_NYR_Load_2.jpg';
import bgImage08 from '../../assets/images/Welcome/08_NJD_Load_2.jpg';
import bgImage09 from '../../assets/images/Welcome/09_NYI_Load_2.jpg';
import bgImage10 from '../../assets/images/Welcome/10_BUF_Load_2.jpg';
import bgImage11 from '../../assets/images/Welcome/11_NYK_Load_3.jpg';
import bgImage12 from '../../assets/images/Welcome/12_NYR_Load_3.jpg';
import bgImage13 from '../../assets/images/Welcome/13_NJD_Load_3.jpg';
import bgImage14 from '../../assets/images/Welcome/14_NYI_Load_3.jpg';
import bgImage15 from '../../assets/images/Welcome/15_BUF_Load_3.jpg';
import * as Ui from './BackgroundChanging.styles';

const imagePaths = [
  bgImage01,
  bgImage02,
  bgImage03,
  bgImage04,
  bgImage05,
  bgImage07,
  bgImage08,
  bgImage09,
  bgImage10,
  bgImage11,
  bgImage12,
  bgImage13,
  bgImage14,
  bgImage15,
];

export const BackgroundChanging = () => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setActive((idx) => (idx + 1) % imagePaths.length);
    }, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <>
      {imagePaths.map((bgImage, idx) => (
        <Ui.BackgroundItem
          key={idx}
          $isActive={active === idx}
          style={{ backgroundImage: `url(${bgImage})` }}
        />
      ))}
    </>
  );
};
